import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'

import { FormData } from '../../ChallengeAdmin'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { CustomTypeCategory, customUnits } from '../../../../services/CustomTypes'
import { ReactComponent as UnitActiveIcon } from '../../../../assets/v3/icons/unit-active.svg'
import YumField from '../../../../components/YumInput/YumInput'
import { ProgressType } from '../../../../services/api.types'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  name: any
  category: CustomTypeCategory
}

export default function ChallengePointsUnitField(props: ChallengePointsUnitFieldProps) {
  const { control, name, category } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumSelect label={t`Unit`} inputRef={ref} {...otherField} style={{ marginBottom: '12px' }}>
          {customUnits.map(
            (unit, keyIndex) =>
              unit.category === category && (
                <option key={keyIndex} value={unit.id}>
                  {unit.text}
                </option>
              ),
          )}
        </YumSelect>
      )}
    />
  )
}
